export default "__VITE_ASSET__d542b713__"